import { render, staticRenderFns } from "./database.vue?vue&type=template&id=1b3be3a4&scoped=true&"
import script from "./database.vue?vue&type=script&lang=js&"
export * from "./database.vue?vue&type=script&lang=js&"
import style0 from "./database.vue?vue&type=style&index=0&id=1b3be3a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3be3a4",
  null
  
)

export default component.exports